module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/varese.ec85e82a335bc44e036a85c4c6b28af4.jpg";